import GrpcService, { PlatformAdminApi } from 'src/services/GrpcService';

import {
  ICreate,
  ISearch,
  IUpdate,
  IRestore,
  IFindById,
  IRemove,
} from 'src/services/ServiceLocator/ServiceLocator.interface';
import { RequestController } from 'src/utils/decorators/request-controller';

class MarketServiceProvider implements ISearch, ICreate, IUpdate, IRestore, IFindById, IRemove {
  @RequestController({ logger: true, retry: true, debounce: true })
  search(params: PlatformAdminApi.IMarketSearchRequest): Promise<PlatformAdminApi.ServicesMarketList> {
    return GrpcService.MarketService.Search(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  create(params: PlatformAdminApi.ICreateServiceMarketRequest): Promise<PlatformAdminApi.ServiceMarketResponse> {
    return GrpcService.MarketService.Create(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  update(params: PlatformAdminApi.IUpdateServiceMarketRequest): Promise<PlatformAdminApi.ServiceMarketResponse> {
    return GrpcService.MarketService.Update(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  restore(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.ServiceMarketResponse> {
    return GrpcService.MarketService.Restore(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  remove(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.ServiceMarketResponse> {
    return GrpcService.MarketService.Remove(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  findById(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.ServiceMarketResponse> {
    return GrpcService.MarketService.FindById(params);
  }
}

export const marketServiceProvider = new MarketServiceProvider();
export type TMarketServiceProvider = typeof marketServiceProvider;
